import React from "react";
import { AudioPlayer,StatusTags, TableAdv} from "../../../../../../components";
import { mapTableRows } from "../../../../../../utils";
import rain from "../../../../../../assets/sound/rain.mp3"

const AiCallHistory = () => {
  const columns = [
    {
      key: "candidateName",
      label: "Candidate Name",
      columnMenu: false,
    },
    {
      key: "role",
      label: "Role",
      columnMenu: false,
    },
    {
      key: "date",
      label: "Date",
      columnMenu: false,
    },
    {
      key: "time",
      label: "Time",
      columnMenu: false,
    },
    {
      key: "status",
      label: "Status",
      columnMenu: false,
      render: (row) => <StatusTags tag={row.status} />,
    },
    {
      key: "duration",
      label: "Call Duration",
      columnMenu: false,
    },
    {
      key: "audio",
      label: "Audio",
      columnMenu: false,
      render: (row) => (
        <AudioPlayer file={rain} download={{ isDownloadable: false }} />
      ),
    },
  ];

  const rows = Array.from({ length: 10 }, (_, i) => ({
    candidateName: "Ershad",
    role: "Frontend Developer",
    date: "05 Mar 2026",
    time: "10:30 AM",
    status: "Answered",
    duration:"10 min",
  }));

  const mappedRows = mapTableRows(rows, columns);
  return (
    <div className="flex flex-col mt-5 overflow-auto">
      <div className="flex flex-grow overflow-auto gap-4 mx-0.5">
        <TableAdv
          showSlNo
          columns={columns}
          rows={mappedRows}
          toolbarRight={{
            search: true,
            filter: true,
            fullScreen: true,
          }}
        />
      </div>
    </div>
  );
}

export default AiCallHistory